import axios from "axios";
import { logout } from "../lib/auth";
import { serviceTableColumn } from "../config/service";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

//  顧客一覧取得
export async function getServices(props: { [key: string]: number | string }) {
  try {
    const path = "services";
    const params = makeParams(serviceTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const services: dataDifine[] = response.data.fetch_data;
    const countServices: string = response.data.count_data;
    return { services, countServices };
  } catch (error) {
    // logout();
  }
}

// 顧客詳細取得
export async function getService(id: string, payment_method_id: string) {
  try {
    const path = "service";
    const params = { id, payment_method_id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const detail_data: {
      [key: string]: number | string;
    } = response.data.detail_data[0];
    return { detail_data };
  } catch (error) {
    // logout();
    return { detail_data: {} };
  }
}

// 顧客情報編集
export async function putService(editData: EditDataDifine) {
  try {
    const path = "service";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
      payment_method_id: editData.payment_method_id,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 顧客情報登録
export async function postService(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "service";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// サービスの取扱い停止・再開
export async function putServiceNoEntryFlg(id: string, startStop: string) {
  try {
    const path = "service/noEntryFlg";
    const params = { id };
    const bodys = { id, startStop };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}
